export default __webpack_public_path__ + "static/media/values.dd543c67.png";